import React from "react";

import Feature3Item from './feature3-item';

function Feature3Items(props) {
  const items = props.feature3Items;
  const itemsDetails = items.map(( item, index ) =>
    // Correct! Key should be specified inside the array.
    <Feature3Item
      key={ item.title.toString() }
      value={ item } 
      index={ index }
      />
  );
  
  return (
      <div className="gtco-flex">
            {itemsDetails}
        </div>
  );
}

export default class Feature3Row extends React.Component {
    render() {
        return (
           <Feature3Items feature3Items={this.props.feature3Items}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/feature3-row.jsx